export function cleanParams(params: any) {
    if (params) {
        return Object.fromEntries(
            Object.entries(params).filter(([_, v]) => v !== '' && v !== null && v !== undefined && v !== 0)
        )
    }
}